/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import Notify from "@eisinc/App/Components/Notify";
import { disableQuoteExpirationEmail } from '@eisinc/App/Services/DisableQuoteExpirationEmail';
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect } from "react-redux";

interface CheqProtectionProps extends WidgetProps {
}

interface State {
    messageType: "success" | "danger" | undefined;
    error: string;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        userToken: parseQueryString<{ userToken: string }>(getLocation(state).search)
    };
};

type Props = CheqProtectionProps & HasHistory & ReturnType<typeof mapStateToProps>;


class DisableQuoteExpirationEmailWidget extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            messageType: undefined,
            error: "",
        }
    }

    componentDidMount = () => {
        this.disableQuoteExpirationEmail(this.props.userToken?.userToken);
    }

    disableQuoteExpirationEmail = (userToken: string) => {
        if (!userToken) {
            return;
        }

        disableQuoteExpirationEmail(userToken).then(
            (response: any) => {
                this.setState({ messageType: "success" });
            },
            (error: any) => {
                this.setState({ messageType: "danger", error: error.message });
            }
        )
    }

    render = () => {
        return (
            <>
                {
                    this.state.messageType && (
                        <Notify
                            messageType={this.state.messageType}
                            body={this.state.messageType === 'success' ? siteMessage("Custom_Disable_Quote_Expiration_Email_Success_Msg") : this.state.error}
                        />
                    )
                }
            </>
        );
    }
}

export const definition: WidgetDefinition = {
    group: "Xngage Custom" as any,
    fieldDefinitions: [

    ],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(DisableQuoteExpirationEmailWidget)),
    definition,
};

export default widgetModule;
